import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7039bf9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-index" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.click_fn && $setup.click_fn(...args))),
      src: _ctx.webpFilters($setup.url)
    }, null, 8, _hoisted_2)
  ]))
}